import { useEffect, useState } from "react";
import axios from "axios";

const questions = {
  question1Value: "How many times do you use Google Maps per week?",
  question2Value: "What do you use it more often for?",
  question3Value: "What is your approximate income per year?",
  question4Value: "Do you live in",
  question1: [
    {
      option: "Zero",
    },
    {
      option: "1-3",
    },
    {
      option: "3-10",
    },
    {
      option: "More",
    },
  ],
  question2: [
    {
      option: "Searching for specific places",
      value: "option1",
    },
    {
      option: "Getting place recommendations",
      value: "option2",
    },
    {
      option: "Navigation",
      value: "option3",
    },
  ],
  question3: [
    {
      option: "$[0-25k",
    },
    {
      option: "$[25k-50k]",
    },
    {
      option: "$[50-100k]",
    },
    {
      option: "More than $100k",
    },
  ],
  question4: [
    {
      option: "Boston/Cambridge?",
    },
    {
      option: "Outside Boston/Cambridge",
    },
  ],
};

const Form = () => {
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isAlreadySubmitted, setIsAlreadySubmitted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Response Already Submitted");
  const [checkboxes, setCheckboxes] = useState({
    option1: false,
    option2: false,
    option3: false,
  });

  const [q1, setQ1] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    console.log(name, checked);
    setCheckboxes({
      ...checkboxes,
      [name]: checked,
    });
  };

  const getCheckboxValue = () => {
    let value = "";
    if (checkboxes.option1) {
      value += questions.question2.find((i) => i.value === "option1").option;
      value += " , ";
    }

    if (checkboxes.option2) {
      value += questions.question2.find((i) => i.value === "option2").option;
      value += " , ";
    }

    if (checkboxes.option3) {
      value += questions.question2.find((i) => i.value === "option3").option;
    }

    return value;
  };

  const handleClick = async () => {
    try {
      const url =
        "https://e9n8gnv782.execute-api.us-east-1.amazonaws.com/survey-dev";
      const payload = {
        q1: questions.question1Value,
        a1: q1,
        q2: questions.question2Value,
        a2: getCheckboxValue(),
        q3: questions.question3Value,
        a3: q3,
        q4: questions.question4Value,
        a4: q4,
      };
      const params = new URLSearchParams(window.location.search);
      const userid = params.get("userid");

      const { data } = await axios.post(url, {
        userid,
        value: JSON.stringify(payload),
      });

      if (data === "User inserted successfully:") {
        setMessage("Response Submitted Successfully");
        setIsAlreadySubmitted(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const getUser = async () => {
      try {
        setLoading(true);
        // Get query parameters from the URL
        const params = new URLSearchParams(window.location.search);
        const yourQueryParam = params.get("userid");
        const { data } = await axios.get(
          `https://e9n8gnv782.execute-api.us-east-1.amazonaws.com/survey-dev?userid=${yourQueryParam}`
        );
        if (data.toString().toLowerCase() === "user already exists") {
          setIsAlreadySubmitted(true);
        } else setIsAlreadySubmitted(false);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    getUser();
  }, []);

  if (loading) {
    return <h1 className="w-full text-center text-2xl mt-5">...Loading</h1>;
  }

  if (isAlreadySubmitted) {
    return <h1 className="w-full text-center text-2xl mt-5">{message}</h1>;
  }

  return (
    <>
      <div
        id="static-modal"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        className={
          isModelOpen
            ? "flex items-center justify-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full "
            : "hidden"
        }
      >
        <div className="relative w-full max-w-2xl max-h-full">
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex items-start justify-between p-4 rounded-t dark:border-gray-600">
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-hide="static-modal"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            <div className="p-6 space-y-6">
              <p className="text-base text-center leading-relaxed text-gray-500 dark:text-gray-400">
                Your Response has been submitted successfully!!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="justify-center flex items-center min-h-screen ">
        <form className="bg-white p-5 md:p-8 max-w-[550px] space-y-8 shadow rounded-lg w-11/12 ">
          <h2 className="text-3xl font-medium">FairMaps Questionnaire</h2>
          <p>
            FairMaps is an experiment by MIT to understand online place
            recommendation algorithms better. We want to measure the difference
            between recommendations made by those algorithms across people from
            different communities and their impact on urban activities.
          </p>
          <p>Let us ask some basic questions about your profile</p>
          <div className="flex flex-col space-y-2">
            <h3 className="mb-2  text-gray-900 ">
              1) {questions.question1Value}
            </h3>
            <ul className="w-48 text-sm font-medium text-gray-900 bg-white  border-gray-200  dark:text-dard">
              {questions.question1.map((i) => (
                <li className="w-full  dark:border-gray-600" key={i.option}>
                  <div className="flex items-center pl-3">
                    <input
                      id="list-radio-license"
                      type="radio"
                      value={q1}
                      onChange={() => setQ1(i.option)}
                      name="list-radio-1"
                      className="w-4 h-4 text-blue-600 bg-gray-100  focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 "
                    />
                    <label
                      htmlFor="list-radio-license"
                      className="w-full py-3 ml-2 text-sm font-medium text-gray-900"
                    >
                      {i.option}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col space-y-2">
            <h3 className="mb-2  text-gray-900 ">
              2) {questions.question2Value}
            </h3>
            <ul className="w-full text-sm font-medium text-gray-900 bg-white  border-gray-200  dark:text-dard">
              {questions.question2.map((i) => (
                <li className="w-full mt-2 dark:border-gray-600" key={i.option}>
                  <div className="flex items-center pl-3">
                    <input
                      id="checked-checkbox"
                      type="checkbox"
                      value={i.value}
                      name={i.value}
                      checked={checkboxes[i.value]}
                      onChange={handleCheckboxChange}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label
                      htmlFor="checked-checkbox"
                      className="ml-2 w-full text-sm font-medium text-gray-900"
                    >
                      {i.option}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col space-y-2">
            <h3 className="mb-2  text-gray-900 ">
              3) {questions.question3Value}
            </h3>
            <ul className="w-48 text-sm font-medium text-gray-900 bg-white  border-gray-200  dark:text-dard">
              {questions.question3.map((i) => (
                <li className="w-full  dark:border-gray-600" key={i.option}>
                  <div className="flex items-center pl-3">
                    <input
                      id="list-radio-license"
                      type="radio"
                      value={q3}
                      onChange={() => setQ3(i.option)}
                      name="list-radio-3"
                      className="w-4 h-4 text-blue-600 bg-gray-100  focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 "
                    />
                    <label
                      htmlFor="list-radio-license"
                      className="w-full py-3 ml-2 text-sm font-medium text-gray-900"
                    >
                      {i.option}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col space-y-2">
            <h3 className="mb-2  text-gray-900 ">
              4) {questions.question4Value}
            </h3>
            <ul className="w-48 text-sm font-medium text-gray-900 bg-white  border-gray-200  dark:text-dard">
              {questions.question4.map((i) => (
                <li className="w-full  dark:border-gray-600" key={i.option}>
                  <div className="flex items-center pl-3">
                    <input
                      id="list-radio-license"
                      type="radio"
                      value={i.option}
                      onChange={() => setQ4(i.option)}
                      name="list-radio-4"
                      className="w-4 h-4 text-blue-600 bg-gray-100  focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 "
                    />
                    <label
                      htmlFor="list-radio-license"
                      className="w-full py-3 ml-2 text-sm font-medium text-gray-900"
                    >
                      {i.option}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <button
            type="button"
            onClick={() => handleClick()}
            disabled={
              !q1.length ||
              !q3.length ||
              !q4.length ||
              (!checkboxes.option1 &&
                !checkboxes.option2 &&
                !checkboxes.option3)
            }
            className="bg-yellow-600 rounde-md w-full p-2 text-white hover:bg-yellow-500 disabled:bg-slate-500"
          >
            Submit
          </button>
        </form>
      </div>
    </>
  );
};

export default Form;
